module.exports = __webpack_public_path__ + "images/128_2048.jpg";